var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ops-section" },
    [
      _c(
        "el-card",
        { staticClass: "ops-page", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "ops-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("评审官设置")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "opsForm",
              staticClass: "ops-form",
              attrs: { model: _vm.form, "label-width": "140px", size: "small" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "ops-block",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "block-title",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_vm._v("评审官资格条件")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "评审官资格 - 消费" } },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, max: 999999, size: "mini" },
                                model: {
                                  value: _vm.form.qualification.consumeAmount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.qualification,
                                      "consumeAmount",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.qualification.consumeAmount",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "tip ml8" }, [
                                _vm._v(
                                  "用户需大于等于此消费金额方可成为评审官"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "评审官资格 - 等级" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "160px" },
                                  attrs: {
                                    placeholder: "请选择",
                                    size: "mini",
                                  },
                                  model: {
                                    value: _vm.form.qualification.minLevel,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.qualification,
                                        "minLevel",
                                        $$v
                                      )
                                    },
                                    expression: "form.qualification.minLevel",
                                  },
                                },
                                _vm._l(_vm.levelOptions, function (opt) {
                                  return _c("el-option", {
                                    key: opt.value,
                                    attrs: {
                                      label: opt.label,
                                      value: opt.value,
                                    },
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "tip ml8" }, [
                                _vm._v("用户需大于此会员等级方可成为评审官"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-card",
                        {
                          staticClass: "ops-block",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "block-title",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_vm._v("评审相关通知文案")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "选为评审官通知" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.notices.selectJudge,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.notices,
                                      "selectJudge",
                                      $$v
                                    )
                                  },
                                  expression: "form.notices.selectJudge",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "成功上墙通知" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.notices.wallSuccess,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.notices,
                                      "wallSuccess",
                                      $$v
                                    )
                                  },
                                  expression: "form.notices.wallSuccess",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "取消评审官通知" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.notices.cancelJudge,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.notices,
                                      "cancelJudge",
                                      $$v
                                    )
                                  },
                                  expression: "form.notices.cancelJudge",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "驳回申请通知" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.notices.rejectApply,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.notices,
                                      "rejectApply",
                                      $$v
                                    )
                                  },
                                  expression: "form.notices.rejectApply",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "违规投票通知" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.notices.illegalVote,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.notices,
                                      "illegalVote",
                                      $$v
                                    )
                                  },
                                  expression: "form.notices.illegalVote",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "ops-block",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "block-title",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_vm._v("评审官视觉标识")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("div", { staticClass: "sub-title" }, [
                                    _vm._v("评审官图标"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: "#",
                                        "list-type": "picture-card",
                                        limit: 1,
                                        "auto-upload": false,
                                        "file-list": _vm.form.visual.judgeIcon,
                                        "on-exceed": _vm.onExceed,
                                        "on-remove": function (f, list) {
                                          _vm.form.visual.judgeIcon = list
                                          _vm.visualPaths.judgeIcon = ""
                                        },
                                        "on-change": function (f, list) {
                                          return _vm.onFileChange(
                                            "judgeIcon",
                                            list
                                          )
                                        },
                                        "on-preview": _vm.handlePreview,
                                        accept: "image/*",
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip",
                                        },
                                        [_vm._v("建议尺寸等比正方形，≤2MB")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("div", { staticClass: "sub-title" }, [
                                    _vm._v("成为评审官图片"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: "#",
                                        "list-type": "picture-card",
                                        limit: 1,
                                        "auto-upload": false,
                                        "file-list":
                                          _vm.form.visual.successImage,
                                        "on-exceed": _vm.onExceed,
                                        "on-remove": function (f, list) {
                                          _vm.form.visual.successImage = list
                                          _vm.visualPaths.successImage = ""
                                        },
                                        "on-change": function (f, list) {
                                          return _vm.onFileChange(
                                            "successImage",
                                            list
                                          )
                                        },
                                        "on-preview": _vm.handlePreview,
                                        accept: "image/*",
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-plus" }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "el-upload__tip",
                                          attrs: { slot: "tip" },
                                          slot: "tip",
                                        },
                                        [_vm._v("建议尺寸等比正方形，≤2MB")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dialog",
                            {
                              attrs: { visible: _vm.dialogVisible },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.dialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "100%" },
                                attrs: { src: _vm.dialogImageUrl },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-card",
                        {
                          staticClass: "ops-block",
                          attrs: { shadow: "never" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "block-title",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_vm._v("评审规则与流程参数")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "评审规则" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 6,
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.form.rules.text,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.rules, "text", $$v)
                                  },
                                  expression: "form.rules.text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "随机投票人数" } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 0,
                                          max: 9999,
                                          size: "mini",
                                        },
                                        model: {
                                          value: _vm.form.rules.randomVoters,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.rules,
                                              "randomVoters",
                                              $$v
                                            )
                                          },
                                          expression: "form.rules.randomVoters",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "上墙同意人数" } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 0,
                                          max: 9999,
                                          size: "mini",
                                        },
                                        model: {
                                          value: _vm.form.rules.agreeToWall,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.rules,
                                              "agreeToWall",
                                              $$v
                                            )
                                          },
                                          expression: "form.rules.agreeToWall",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-tip" }, [
                                        _vm._v("需要大于等于投票人数"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "投票时间" } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 1,
                                          max: 240,
                                          size: "mini",
                                        },
                                        model: {
                                          value: _vm.form.rules.voteHours,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.rules,
                                              "voteHours",
                                              $$v
                                            )
                                          },
                                          expression: "form.rules.voteHours",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-tip" }, [
                                        _vm._v("通过审核开始后至多少小时结束"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "申请限制" } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 0,
                                          max: 240,
                                          size: "mini",
                                        },
                                        model: {
                                          value:
                                            _vm.form.rules.applyCooldownHours,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.rules,
                                              "applyCooldownHours",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.rules.applyCooldownHours",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-tip" }, [
                                        _vm._v(
                                          "用户发帖在该次数限制内可以发起申请"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "上墙时间" } },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, max: 240, size: "mini" },
                                model: {
                                  value: _vm.form.rules.wallHours,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.rules, "wallHours", $$v)
                                  },
                                  expression: "form.rules.wallHours",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-tip" }, [
                                _vm._v(
                                  "用户发帖在该时间后可以上墙（24小时制）"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ops-actions" },
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }